import React, { useEffect, useRef } from 'react';
import { urlFor } from '../sanityClient';

const ProjectItem = ({ project = {}, delay = 0 }) => {
    const itemRef = useRef(null);
    const imgRef = useRef(null);

    useEffect(() => {
        const el = imgRef.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    el.classList.add('img-fade--visible');
                    observer.disconnect();
                }
            },
            { threshold: 0 }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            entry.target.classList.add('visible');
                        }, delay);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (itemRef.current) {
            observer.observe(itemRef.current);
        }

        const el = itemRef.current;
        return () => {
            if (el) observer.unobserve(el);
        };
    }, [delay]);

    if (!project || Object.keys(project).length === 0) {
        return <div>No project available</div>;
    }

    const projectUrl = project.link || '#';
    const imageUrl = project.thumbnail ? urlFor(project.thumbnail).width(800).url() : '';

    return (
        <a
            href={projectUrl}
            className="project-item"
            ref={itemRef}
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className="img-container">
                <picture ref={imgRef} className="img-fade">
                    <img
                        src={imageUrl}
                        alt={project.company}
                        loading="lazy"
                        className="w-100"
                    />
                </picture>
            </div>
            <div className="text">
                <h2>{project.company}</h2>
                <span>{project.description}</span>
            </div>
        </a>
    );
};

export default ProjectItem;
